import React, { Dispatch, SetStateAction } from "react";
import RadioBtn from "../../../../../Button/RadioBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import CheckBox from "../../../../../Button/CheckBox";
import { useLocation } from "react-router-dom";

interface FaqPubicInputProps {
  check: {
    public: boolean;
    private: boolean;
  };
  setCheck: Dispatch<
    SetStateAction<{
      public: boolean;
      private: boolean;
      top: boolean;
      normal: boolean;
      hasService: boolean;
      noService: boolean;
    }>
  >;
  publicRange?: {
    faq: boolean;
    myparty: boolean;
  };
  setPublicRange?: Dispatch<
    SetStateAction<{
      faq: boolean;
      myparty: boolean;
    }>
  >;
  isEditMode: boolean;
}

export default function FaqPubicInput({
  check,
  setCheck,
  publicRange,
  setPublicRange,
  isEditMode,
}: FaqPubicInputProps) {
  const { pathname } = useLocation();

  const isFaq = Boolean(pathname.includes("faq"));

  return (
    <FaqDetailRow style={{ padding: "10px 0" }}>
      <FaqDetailLabel>공개 여부</FaqDetailLabel>

      <div>
        <Flex gapSize={55} style={{ padding: "10px 0" }}>
          <RadioBtn
            label="공개"
            noTooltip={true}
            check={check?.public}
            clickEvent={() =>
              setCheck((prev) => ({
                ...prev,
                public: !prev.public,
                private: false,
              }))
            }
            disabled={!isEditMode}
          />

          <RadioBtn
            label="비공개"
            noTooltip={true}
            check={check?.private}
            clickEvent={() =>
              setCheck((prev) => ({
                ...prev,
                public: false,
                private: !prev.private,
              }))
            }
            disabled={!isEditMode}
          />
        </Flex>

        {isFaq && check?.public && (
          <Flex gapSize={33} style={{ marginLeft: 30, marginTop: 10 }}>
            <CheckBox
              label="고객센터"
              checked={publicRange?.faq}
              onChange={(e: { target: { checked: boolean } }) => {
                if (setPublicRange)
                  setPublicRange((prev) => ({
                    ...prev,
                    faq: e.target.checked,
                  }));
              }}
              disabled={!isEditMode}
            />

            <CheckBox
              label="나의 파티"
              checked={publicRange?.myparty}
              onChange={(e: { target: { checked: boolean } }) => {
                if (setPublicRange)
                  setPublicRange((prev) => ({
                    ...prev,
                    myparty: e.target.checked,
                  }));
              }}
              disabled={!isEditMode}
            />
          </Flex>
        )}
      </div>
    </FaqDetailRow>
  );
}
